Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.location = exports.metrics = undefined;

var _propTypes = require("prop-types");

var metrics = exports.metrics = _propTypes.object;

var location = exports.location = (0, _propTypes.shape)({
    pathname: _propTypes.string.isRequired,
    search: _propTypes.string.isRequired,
    query: _propTypes.object,
    state: _propTypes.object
});

exports.default = {
    metrics: metrics,
    location: location
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-metrics/lib/react/PropTypes.js
// module id = 207
// module chunks = 31